import { TimetableReports } from '../../../components/EvaluateTimetable/TimetableReports';

export const EvaluateByClass = () => {
  return <TimetableReports topic='classes' />;
};
